export default function addSpacesToPDCN(partnerDiscountCardNumber) {
  return partnerDiscountCardNumber.split('').map((char, index) => {
    if ([2, 6, 13].indexOf(index) !== -1) {
      return ` ${char}`;
    }
    return char;
  }).join('');
}
